var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 22C44 34.1458 34.1458 44 22 44C9.85416 44 0 34.1458 0 22C0 9.85416 9.85416 0 22 0C34.1458 0 44 9.85416 44 22Z",
    fill: "#F4F9FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 13L24 21L17 29",
    stroke: "black",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavRight);
export default __webpack_public_path__ + "static/media/nav-right.131078ddd76f31eb813a7df8f6cfae7b.svg";
export { ForwardRef as ReactComponent };